import { render, staticRenderFns } from "./medicalStatistics.vue?vue&type=template&id=c9749dc2&scoped=true"
import script from "./medicalStatistics.vue?vue&type=script&lang=js"
export * from "./medicalStatistics.vue?vue&type=script&lang=js"
import style0 from "./medicalStatistics.vue?vue&type=style&index=0&id=c9749dc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9749dc2",
  null
  
)

export default component.exports